import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';

export const Body = styled(Flex)`
  flex-direction: column;
  align-items: center;

  ${({ theme }) => css`
    padding: ${theme.spacing(4, 2)};
    background-color: ${theme.colors.lightGrey};

    ${theme.media.md.up} {
      padding: ${theme.spacing(10, 0, 5, 0)};
    }
  `}
`;

export const BagImageWrapper = styled(Box)`
  position: relative;
  height: 97px;
  width: 73px;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.md.up} {
      height: 118px;
      width: 88px;
    }
  `}
`;

export const BagImage = styled(NextImage)`
  object-fit: contain;
`;

export const YourShoppingBagIsEmpty = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.h4};
    color: ${theme.colors.secondary};

    ${theme.media.md.up} {
      line-height: 1;
      font-size: ${theme.fontSizes.h3};
    }
  `}
`;

export const FreeShippingAndReturns = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`;

export const ContinueShoppingButton = styled(LegacyButton)`
  width: 100%;
  text-decoration: none;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};

    ${theme.media.md.up} {
      width: 250px;
    }
  `}
`;
